<template>
	<div class="p-grid">
		<div class="p-col-12">
            <h3 style="color:#ffcc2a;">{{$t('Broker')}}</h3>
        </div>		
		<div class="p-col-12">
			<div class="p-grid">
				<div class="p-col-12">
					<div class="card">
						<DataTable :value="products" :paginator="true" class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
								:rows="25" dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" :filters="filters">
							<template #header>
								<div class="table-header">
									<span class="p-input-icon-left">
										<i class="pi pi-search" />
										<InputText v-model="filters['global']" placeholder="Buscar..." />
									</span>
								</div>
							</template>
							<Column field="nombre" :header="$t('Nombre')" :sortable="true">
								<template #body="slotProps">
									{{slotProps.data.nombre}}
								</template>
							</Column>
							<Column field="origen" :header="$t('Oficina')" :sortable="true" >
								<template #body="slotProps">
									{{slotProps.data.origen}}
								</template>
							</Column>
							<Column header="Opciones" headerStyle="width: 150px">
								<template #body="slotProps">
									<Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" @click="editProduct(slotProps.data)" v-if="edit"/>
								</template>
							</Column>
						</DataTable>
					</div>
				</div>
			</div>
		</div>


			<Dialog v-model:visible="productDialog" :style="{width: size}" :header="$t('Broker')" :modal="true" class="p-fluid">
				<br>
                <div class="p-field">
					<div class="p-grid">
						<div class="p-col-12">
							{{$t('Nombre')}}: {{product.nombre}}
						</div>
						<div class="p-col-12">
							{{$t('Oficina')}}: {{product.origen}}
						</div>
						<div class="p-col-12">

							<DataTable :value="products2" v-model:expandedRows="expandedRows" dataKey="id"
								@rowExpand="onRowExpand" @rowCollapse="onRowCollapse" responsiveLayout="scroll">
								<Column :expander="true" headerStyle="width: 3rem" />					
								<Column field="nombre" :header="$t('Nombre')" :sortable="true">
									<template #body="slotProps">
										<div v-if="i18n.locale() == 'es'">
											{{slotProps.data.nombre}}
										</div>
										<div v-else>
											{{slotProps.data.name}}
										</div>
									</template>
								</Column>
								<template #expansion="slotProps">
									<div class="orders-subtable">
										<DataTable :value="slotProps.data.opciones" responsiveLayout="scroll">
											<Column field="tipocliente" :header="$t('Dirigido a')">
												<template #body="slotProps">
													<div v-if="i18n.locale() == 'es'">{{slotProps.data.nombre}}</div>
													<div v-if="i18n.locale() == 'en'">{{slotProps.data.name}}</div>
												</template>
											</Column>
											<Column field="limite" :header="$t('Factor')">
												<template #body="slotProps">
													<InputText v-model="slotProps.data.porcentaje" type="number" min="0" style="max-width:100px;"/>
												</template>
											</Column>
										</DataTable>
									</div>
								</template>
							</DataTable>
						</div>						
					</div>
				</div>
				<template #footer>
					<Button label="Guardar" icon="pi pi-check" class="p-button-secondary" @click="Save()" />
					<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="productDialog=false"/>
				</template>
			</Dialog>


</div>

</template>

<script>
	import API from "../service/ApiConsulta";
    import { useI18nPlugin } from '@unify/vuex-i18n';

	export default {
		data() {
			return {
                i18n: null,
				insert: false,
				edit: false,
				del: false,
				products: [],
				products2: [],
				valores: [],
				productDialog: false,
				permisosDialog: false,
				deleteProductDialog: false,
				deleteProductsDialog: false,
				product: {},
				filters: {},
				submitted: false,
				size: '60vw',
				niveles: null,
				expandedRows: [] 
			}
		},
		productService: null,
		created() {
            this.i18n = useI18nPlugin();
			this.$store.commit('Validar',this.$route);
			if (this.$store.state.mobile){this.size = '90vw';}
			this.Mostrar();
		},
		mounted() {
			
		},
		methods: {
			Mostrar() {
				this.products = [];
				this.$store.commit('Loading');
				const Consulta = new API('Configuracion');
				Consulta.Ini('Broker').then(result => {
					//this.$store.state.error = result;
					this.insert = result.insert;
					this.edit = result.edit;
					this.del = result.delete;
					this.products = result.consult.broker;
					this.$store.commit('Loading');
				}); 
			},
			editProduct(product) {
				this.$store.commit('Loading');
				this.product = {...product};
				const Consulta = new API('Configuracion');          
				Consulta.Procesar('Broker',{
					caso: 	'VER',
					product: product
				}).then(response => {
					//this.$store.state.error =response;
					if (response.result) {
						this.products2 = response.result;
						this.productDialog = true;
						this.$store.commit('Loading');
					} 
				});
			},
			Save() {
				this.$store.commit('Loading');
				const Consulta = new API('Configuracion');          
				Consulta.Procesar('Broker',{
					caso: 	'UPD',
					products: this.products2
				}).then(response => {
					//this.$store.state.error =response;
					if (response.result) {
						this.$toast.add({
							severity:'success', 
							summary: 'Éxito', 
							detail: 'Información Procesada', 
							life: 3000
						});
						this.$store.commit('Loading');
						this.productDialog = false;
					} else {
						this.$toast.add({
							severity:'warn', 
							summary: 'Advertencia', 
							detail: 'No fue procesada la solicitud', 
							life: 3000
						});
						this.$store.commit('Loading');
					}
				});
			},
			findIndexById(id) {
				let index = -1;
				for (let i = 0; i < this.products.length; i++) {
					if (this.products[i].id === id) {
						index = i;
						break;
					}
				}

				return index;
			},
			createId() {
				let id = '';
				var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				for ( var i = 0; i < 5; i++ ) {
					id += chars.charAt(Math.floor(Math.random() * chars.length));
				}
				return id;
			},
			exportCSV() {
				this.$refs.dt.exportCSV();
			},
            expandAll() {
                this.expandedRows = this.products.filter(p => p.id);
            },
            collapseAll() {
                this.expandedRows = null;
            },
		}
	}
</script>

<style scoped lang="scss">
.table-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .product-image {
	width: 150px;
	margin: 0 auto 2rem auto;
	display: block;
}

.confirmation-content {
	display: flex;
	align-items: center;
	justify-content: center;
}

.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
    display: none;
}

@media screen and (max-width: 40em) {
    ::v-deep(.p-datatable) {
        &.p-datatable-responsive-demo {
            .p-datatable-thead > tr > th,
            .p-datatable-tfoot > tr > td {
                display: none !important;
            }

            .p-datatable-tbody > tr > td {
                text-align: left;
                display: block;
                width: 100%;
                float: left;
                clear: left;
                border: 0 none;

                .p-column-title {
                    padding: .4rem;
                    min-width: 30%;
                    display: inline-block;
                    margin: -.4em 1em -.4em -.4rem;
                    font-weight: bold;
                }

                &:last-child {
					border-bottom: 1px solid var(--surface-d);
					text-align: center;
				}
				
				.p-rating {
					display: inline-block;
				}
            }
        }
    }
}
</style>
